export default "https://cdn-static-staging.gokick.com/assets/fcb4ac80126f26ea915890c2472f26527471791c/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";